module.exports = __webpack_public_path__ + "img/person-biking-mountain.4b750d45.svg";